import React from "react";
import PropTypes from "prop-types";
import { FormType } from "./CardForm";
import * as Styled from "./misc/styled";
import { mediaUrl } from "../../../helpers/CoreHelpers";

const CardField = (props) => {
  const { data, onShowForm, onDelete } = props;
  const { id, imgSrc, title, description } = data;

  const handleOnEdit = (e) => {
    e.preventDefault();

    onShowForm({
      formData: { ...data },
      formType: FormType.Edit,
    });
  };

  const handleOnView = (e) => {
    e.preventDefault();

    onShowForm({
      formData: { ...data },
      formType: FormType.ReadOnly,
    });
  };

  const handleOnDelete = (e) => {
    e.preventDefault();
    onDelete(id);
  };

  return (
    <Styled.CardField imgSrc={mediaUrl(imgSrc)}>
      <div className="cover">
        <div className="image" />
      </div>
      <div className="body">
        <p className="title" title={title}>
          {title}
        </p>
        <span className="description" title={description}>
          {description}
        </span>
      </div>
      <div className="actions">
        <a role="button" onClick={handleOnView}>
          view
        </a>
        <a role="button" onClick={handleOnEdit}>
          edit
        </a>
        <a role="button" onClick={handleOnDelete}>
          delete
        </a>
      </div>
    </Styled.CardField>
  );
};

CardField.propTypes = {
  data: {}, // TODO FIX!
  onShowForm: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CardField;



// WEBPACK FOOTER //
// ./src/core/admin/components/CardGrid/CardField.js